__turbopack_context__.v({
  "appear-slide-left": "ContactContent-module-scss-module__GN9yzW__appear-slide-left",
  "bounceTwice": "ContactContent-module-scss-module__GN9yzW__bounceTwice",
  "contactForm": "ContactContent-module-scss-module__GN9yzW__contactForm",
  "contactItem": "ContactContent-module-scss-module__GN9yzW__contactItem",
  "content": "ContactContent-module-scss-module__GN9yzW__content",
  "fade-in-bottom": "ContactContent-module-scss-module__GN9yzW__fade-in-bottom",
  "fade-in-left": "ContactContent-module-scss-module__GN9yzW__fade-in-left",
  "fade-in-right": "ContactContent-module-scss-module__GN9yzW__fade-in-right",
  "fadeIn": "ContactContent-module-scss-module__GN9yzW__fadeIn",
  "flexContainer": "ContactContent-module-scss-module__GN9yzW__flexContainer",
  "icon": "ContactContent-module-scss-module__GN9yzW__icon",
  "iconContainer": "ContactContent-module-scss-module__GN9yzW__iconContainer",
  "label": "ContactContent-module-scss-module__GN9yzW__label",
  "loader": "ContactContent-module-scss-module__GN9yzW__loader",
  "map": "ContactContent-module-scss-module__GN9yzW__map",
  "napContainer": "ContactContent-module-scss-module__GN9yzW__napContainer",
  "puff-in-center": "ContactContent-module-scss-module__GN9yzW__puff-in-center",
  "puff-in-left": "ContactContent-module-scss-module__GN9yzW__puff-in-left",
  "pulse": "ContactContent-module-scss-module__GN9yzW__pulse",
  "pulse-contact": "ContactContent-module-scss-module__GN9yzW__pulse-contact",
  "shake-bottom": "ContactContent-module-scss-module__GN9yzW__shake-bottom",
  "slide-again": "ContactContent-module-scss-module__GN9yzW__slide-again",
  "slide-in-right": "ContactContent-module-scss-module__GN9yzW__slide-in-right",
  "stepContent-entrance": "ContactContent-module-scss-module__GN9yzW__stepContent-entrance",
  "wrapper": "ContactContent-module-scss-module__GN9yzW__wrapper",
});
